// ----------------------------------------------------------------------- imports externos
import { NavLink } from "react-router-dom";

// ----------------------------------------------------------------------- imports internos
import { SECCIONES, puedeVer } from "./secciones";
import { destinos } from "./atajosBarra";
import Icono from "./Icono";

/* La barra de abajo, en el teléfono.
 *
 * Existe porque portería carga con la barrera abajo y un camión esperando, y
 * el taller con las manos sucias: recorrer 25 entradas en un cajón lateral es
 * la diferencia entre cargarlo y no cargarlo.
 *
 * ── SÓLO EN ANGOSTO, Y POR CSS ───────────────────────────────────────────
 *
 * Se dibuja siempre y la esconde una `@media`. Con un `matchMedia` en
 * JavaScript, la barra aparecería después del primer pintado —o peor, al girar
 * el teléfono habría que acordarse de escuchar el cambio— y una barra que
 * parpadea se lee como una pantalla que cargó mal.
 *
 * ── QUÉ ATAJOS Y POR QUÉ ─────────────────────────────────────────────────
 *
 * Inicio fijo, dos del sector de la persona, y Menú. La regla vive en
 * `atajosBarra.js` y se prueba sola; acá sólo se dibuja.
 *
 * **Menú no es una ruta**: es la acción de abrir el rail entero, que sigue
 * teniendo las veinticinco pantallas. Esto acorta el camino, no esconde la
 * puerta.
 */
const BarraAbajo = ({ permisos = null, onMenu, onNavegar }) => {
  /* Los mismos grupos que ve el rail, filtrados igual. Mientras los permisos
   * no llegaron se toma el catálogo entero, como en todo el resto del hub: la
   * barra se acomoda una vez al cargar y no parpadea vacía. */
  const grupos = SECCIONES.map((g) => ({
    ...g,
    items: g.items.filter((i) => puedeVer(i, permisos)),
  })).filter((g) => g.items.length > 0);

  const items = destinos(grupos);

  return (
    <nav className="barra-abajo" aria-label="Accesos rápidos">
      {items.map((d) => (
        <NavLink
          key={d.id}
          to={d.ruta}
          onClick={onNavegar}
          end={d.ruta === "/"}
          className={({ isActive }) =>
            "barra-abajo-item" + (isActive ? " activo" : "")
          }
        >
          <Icono nombre={d.icono || "punto"} size={20} className="barra-abajo-ico" />
          <span className="barra-abajo-rot">{d.label}</span>
        </NavLink>
      ))}
      <button type="button" className="barra-abajo-item" onClick={onMenu}>
        <Icono nombre="menu" size={20} className="barra-abajo-ico" />
        <span className="barra-abajo-rot">Menú</span>
      </button>
    </nav>
  );
};

export default BarraAbajo;
